<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" :paramsRoute="paramsRoute" />
      <v-card>
        <v-card-text :class="[list.length < 6 ? 'calendar' : '']">
          <v-data-table
            :headers="headers"
            :items="list"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
            }"
            no-results-text="Sin resultados coincidentes con la búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
          >
            <template v-slot:top>
              <div class="row">
                <branch-offices-list
                  :model="idBranchOfficeSelected"
                  :classOfDiv="cols"
                  style="padding-top: 22px"
                  v-on:triggerChange="branchOfficeSelected"
                />
                <div v-if="isViewAdmin()" class="col-sm-12 col-md-2">
                  <div style="padding-top: 9px">
                    <v-autocomplete
                      v-model="modalitiesSelect"
                      :items="modalities"
                      item-text="name"
                      item-value="idModality"
                      auto-select-first
                      clearable
                      label="Modalidad"
                      @change="filterModality()"
                      no-data-text="Sin resultados disponibles"
                    />
                  </div>
                </div>
                <div v-if="isViewAdmin()" class="col-md-2 col-xl-2 col-sm-12">
                  <div style="padding-top: 9px">
                    <v-autocomplete
                      v-model="studyProfileSelect"
                      :items="studyProfileList"
                      item-text="name"
                      item-value="idStudyModality"
                      auto-select-first
                      clearable
                      label="Perfil de estudio"
                      @change="listAll()"
                      no-data-text="Sin resultados disponibles"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-2">
                  <div
                    class="text-right pl-5"
                    id="handCalendar"
                    style="padding-top: 9px"
                  >
                    <vc-date-picker
                      color="green"
                      v-model="date"
                      :max-date="new Date()"
                      is-range
                    >
                      <template v-slot="{ inputEvents }">
                        <div class="flex justify-center items-center">
                          <v-text-field
                            v-on="inputEvents.start"
                            :value="dateCompuded"
                            label="Seleccione fecha"
                            :append-icon="
                              validData ? 'mdi-eraser' : 'mdi-calendar'
                            "
                            @click:append="clearCalendar"
                            :disabled-input="validData"
                          ></v-text-field>
                        </div>
                      </template>
                    </vc-date-picker>
                  </div>
                </div>
                <div class="col">
                  <v-text-field
                    style="padding-top: 22px"
                    v-model="search"
                    label="Buscar"
                    class="pl-1"
                    :append-icon="search ? 'mdi-eraser' : 'mdi-magnify'"
                    @click:append="search = ''"
                  ></v-text-field>
                </div>
              </div>
            </template>

            <!-- ACCIONES DE TABLA -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip
                top
                v-if="
                  $utilFront.withPermission($prm.IMAGE_CLOSE) ||
                    $utilFront.withPermission($prm.LABORATORY_VALIDATE)
                "
              >
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    color="warning"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="close(item)"
                    :disabled="sending"
                  >
                    <v-icon>mdi-folder-lock</v-icon>
                  </v-btn>
                </template>
                <span>{{ titleClose }}</span>
              </v-tooltip>

              <v-menu
                offset-y
                :nudge-width="100"
                :close-on-content-click="true"
                v-if="
                  (speciality == 3 &&
                    $utilFront.withPermission($prm.LABORATORY_TAG)) ||
                    $utilFront.withPermission($prm.LABORATORY_CANCEL) ||
                    $utilFront.withPermission($prm.IMAGE_CANCEL) ||
                    $utilFront.withPermission($prm.VIEWER_WEB)
                "
              >
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <span>Más opciones</span>
                  </v-tooltip>
                </template>

                <v-list dense>
                  <v-list-item
                    link
                    @click="downloadBarcode(item.idStudy)"
                    :disabled="sending"
                    v-if="
                      speciality == 3 &&
                        $utilFront.withPermission($prm.LABORATORY_TAG)
                    "
                  >
                    <v-list-item-icon>
                      <v-icon> mdi-barcode </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Generar etiqueta </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    link
                    @click="cancel(item)"
                    :disabled="sending"
                    v-if="
                      $utilFront.withPermission($prm.LABORATORY_CANCEL) ||
                        $utilFront.withPermission($prm.IMAGE_CANCEL)
                    "
                  >
                    <v-list-item-icon>
                      <v-icon color="error"> mdi-stop </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Cancelar estudio </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <!-- Ejemplo componente <view-image-item> -->
                  <view-image-item
                    v-if="
                      speciality == 2 &&
                        $utilFront.withPermission($prm.VIEWER_WEB_IMG)
                    "
                    :send="() => (sending = !sending)"
                    :sending="sending"
                    :idStudy="item.idStudy"
                  />
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="justify-center">
          <export-import-btn
            class="mx-2"
            texto="Exportar Excel"
            icono="export"
            color="green darken-1"
            @accion="downloadReport(2)"
          />
         <!--  <export-import-btn
            class="mx-2"
            texto="Estudios pendientes de Papanicolaou"
            icono="export"
            color="green darken-1"
            @accion="downloadExcelPapa(3)"
          /> -->

          <!-- <export-import-btn
            class="mx-2"
            texto="Estudios pendientes de Papanicolaou"
            icono="export"
            color="green darken-1"
            @accion="dialogPapa = true"
          /> -->

          <!-- modal con calendario -->
          <v-dialog
            v-model="dialogPapa"
            max-width="400px"
            persistent
          >
            <v-card>
              <v-card-title class="headline">
                Descargar estudios pendientes
              </v-card-title>

              <v-card-text>
                <validation-provider rules="required" v-slot="{ errors }">
                  <vc-date-picker
                    v-model="modalDate"
                    :max-date="new Date()"
                    color="green"
                    is-range
                    is-required
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-card-text>

              <v-card-actions class="justify-end">
                <v-btn color="red" text @click="dialogPapa = false">Cancelar</v-btn>
                <v-btn
                  color="primary"
                  text
                  :disabled="!dateRangeSelected"
                  :loading="sending"
                  @click="onConfirmPapa"
                >
                  Aceptar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-actions>
      </v-card>

      <!-- DIALOGO EXISTENTE: Cerrar estudio (Imagen) -->
      <v-dialog v-model="dialog" persistent max-width="1000" v-if="dialog">
        <v-card>
          <v-card-title class="text-h6 text-center">
            <span class="success--text"> ¿Desea Cerrar éste estudio?</span>
          </v-card-title>

          <div class="container">
            <patient-information :model="dataModal" />
            <br />
            <v-subheader
              ><v-icon> mdi-clipboard-text </v-icon>Datos Generales del Estudio
            </v-subheader>
            <v-divider class="mb-5"></v-divider>
            <v-row align="center">
              <v-col>
                <p class="font-weight-black">
                  Modalidad:<br />
                  <span class="font-weight-regular">{{
                    dataModal.nameModality
                  }}</span>
                </p>
              </v-col>
              <v-col>
                <p class="font-weight-black">
                  Estudio:<br />
                  <span class="font-weight-regular">{{
                    dataModal.nameStudy
                  }}</span>
                </p>
              </v-col>
              <v-col>
                <p class="font-weight-black">
                  Id Estudio:<br />
                  <span class="font-weight-regular">{{
                    dataModal.idStudy
                  }}</span>
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <p class="font-weight-black success--text">
                  Accession Number:<br />
                  <span class="font-weight-black">{{
                    dataModal.accessionNumber
                  }}</span>
                </p>
              </v-col>
              <v-col>
                <p class="font-weight-black success--text">
                  Imágenes:<br />
                  <span class="font-weight-black">{{ quantityImages }}</span>
                </p>
              </v-col>
            </v-row>
            <br />
          </div>

          <!-- Muestra resultados en caso de speciality=3 (Laboratorio) -->
          <div v-if="speciality == 3">
            <v-simple-table dense fixed-header>
              <thead>
                <tr>
                  <th>Parametro</th>
                  <th>Resultados</th>
                  <th>Unidad</th>
                  <th>V. de Referencia</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(lab, index) in laboratoryResults.resultados"
                  :key="lab.parametro"
                  :id="index"
                >
                  <td>
                    <b>{{ lab.parametro }}</b
                    ><br />
                    Método: {{ lab.resultados.tecnica }}<br />
                    Muestra: {{ lab.resultados.tipo }}
                  </td>
                  <td>{{ lab.resultados.resultadoNumb }}</td>
                  <td>{{ lab.resultados.unidadmedida }}</td>
                  <td v-html="lab.resultados.val_ref"></td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>

          
          
          <!-- Texto Motivo / Observacion -->
          <validation-observer ref="observer" v-slot="{ invalid }">
            <validation-provider
              v-slot="{ errors }"
              name="Motivo"
              rules="required|min:6"
            >
              <div class="container">
                <v-textarea
                  outlined
                  v-model="reason"
                  label="Observación"
                  :error-messages="errors"
                  :counter="300"
                  :maxlength="300"
                ></v-textarea>
              </div>
            </validation-provider>

            <v-row align="center" justify="center">
                  <v-col cols="5">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Adjuntar archivos"
                       
                        ref="filesProvider"
                    >
                      <v-file-input
                        v-if="dataModal.nameModality === 'COLPOSCOPIA'"
                        multiple
                        v-model="colposcopyFiles"
                        placeholder="Seleccione los archivos"
                        label="Adjuntar archivos"
                        accept=".pdf,application/pdf"
                        show-size
                        counter
                        prepend-icon="mdi-paperclip"
                        :disabled="isReadOnly"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="dialog = false">
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                text
                :loading="sending"
                :disabled="
                  sending ||
                  (dataModal.nameModality === 'COLPOSCOPIA'
                    ? !validColpo
                    : invalid
                  )
                "
                @click="handleAcceptModal()"
              >
                Aceptar
              </v-btn>
            </v-card-actions>
            
          </validation-observer>
        </v-card>
      </v-dialog>

      <!-- DIALOGO EXISTENTE: Cancelar estudio -->
      <v-dialog v-model="dialog2" persistent max-width="1000" v-if="dialog2">
        <v-card>
          <v-card-title class="text-h6 text-center">
            <span class="error--text">¿Desea cancelar este estudio?</span>
          </v-card-title>

          <validation-observer ref="observer" v-slot="{ invalid }">
            <v-card-text>
              <v-container>
                <v-row dense class="mt-2">
                  <v-col cols="12" md="12" sm="12">
                    <patient-information :model="dataModal" />
                  </v-col>
                  <v-col cols="12" md="12" sm="12">
                    <PatientInterpretationAppoInfo :model="dataModal" />
                  </v-col>
                </v-row>

                <v-row class="mt-4">
                  <v-col v-if="speciality == 2">
                    <h3 class="font-weight-black primary--text">
                      Accession Number: {{ dataModal.accessionNumber }}
                    </h3>
                  </v-col>
                  <v-col v-if="speciality == 3">
                    <h3 class="font-weight-black primary--text">
                      Id Etiqueta: {{ dataModal.laboratoryLabel }}
                    </h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black mt-5">Motivo</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col
                          @click.right.prevent
                          @copy.prevent
                          @paste.prevent
                          ondrop="return false;"
                        >
                          <validation-provider
                            v-slot="{ errors }"
                            name="Motivo"
                            rules="required|min:6"
                          >
                            <v-textarea
                              outlined
                              v-model="reason"
                              :value="reason"
                              :error-messages="errors"
                              label="Motivo de cancelación"
                              id="cancellation"
                              required
                              :counter="300"
                              :maxlength="300"
                            ></v-textarea>
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions class="text-center">
              <v-col>
                <v-btn color="error" plain @click="closeCancel()">
                  Volver <v-icon right>mdi-close</v-icon>
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  :disabled="sending || invalid"
                  color="primary"
                  @click="cancelStudy(dataModal.idStudy)"
                >
                  Cancelar estudio <v-icon right>mdi-stop</v-icon>
                </v-btn>
              </v-col>
            </v-card-actions>
          </validation-observer>
        </v-card>
      </v-dialog>

      <!-- DIALOGO EXISTENTE: Etiquetas -->
      <v-dialog v-model="dialog3" persistent max-width="450" v-if="dialog3">
        <v-card>
          <v-card-title class="text-h6 text-center"> Etiqueta </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <h3 class="font-weight-bold">
                    Id Estudio:
                    <span class="error--text">{{ tagModal.idStudy }}</span>
                  </h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3 class="font-weight-bold">
                    Paciente:
                    <span class="font-weight-medium">{{
                      tagModal.fullNamePatient
                    }}</span>
                  </h3>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="text-center">
            <v-col>
              <v-btn color="error" plain @click="dialog3 = false">
                <v-icon left>mdi-close</v-icon>
                Cancelar
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                :disabled="sending"
                color="primary"
                @click="downloadBarcode(tagModal.idStudy)"
              >
                Generar etiqueta <v-icon right>mdi-barcode</v-icon>
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <ValidationObserver v-slot="{ invalid }">
      <v-dialog
        v-model="myPapModalVisible"
        max-width="980"
        persistent
        v-if="myPapModalVisible"
      >
        <v-card>
          <v-card-title style="color: #60845c; margin-top: 10px;">
            ¿Desea cerrar este estudio?
          </v-card-title>

          <v-card-text>
            <!-- Información de paciente y estudio -->
            <v-row v-if="dataModal && dataModal.idPatient">
              <v-col cols="12" md="12" sm="12">
                <patient-information :model="dataModal" />
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <PatientInterpretationAppoInfo :model="dataModal" />
              </v-col>
            </v-row>

            <!-- Botón "Información de consulta" -->
            <div class="text-center" style="margin-top: 20px;">
              <v-btn
                color="info"
                class="white--text font-weight-bold"
                @click="openInfoConsulta(dataModal)"
              >
                INFORMACIÓN DE CONSULTA
                <v-icon right>mdi-information</v-icon>
              </v-btn>
            </div>
            <h3 class="font-weight-bold mb-4" style="margin-top: 20px;">
              Resultados
            </h3>

            <!-- 1) RESULTADOS DEL ESTUDIO CITOLÓGICO -->
            <ValidationProvider name="Resultados citológicos" rules="required" v-slot="{ errors }">
            <v-row class="align-center mb-3">
              <!-- Etiqueta a la izquierda -->
              <v-col cols="12" sm="4" md="4" lg="3" class="text-right">
                <span class="font-weight-bold"
                  >Resultados del estudio citológico:</span
                >
              </v-col>

              <v-col cols="12" sm="8" md="8" lg="9">
                <v-select
                  v-model="resultsCytology"
                  :items="listResultsCytology"
                  placeholder="Seleccionar una opción"
                  solo
                  hide-details
                  dense
                  :error-messages="errors"
                />
              </v-col>
            </v-row>
          </ValidationProvider>

            <!-- 2) HALLAZGOS ADICIONALES -->
            <ValidationProvider name="Hallazgos adicionales" rules="required" v-slot="{ errors }">
            <v-row class="align-center mb-3">
              <v-col cols="12" sm="4" md="4" lg="3" class="text-right">
                <span class="font-weight-bold">Hallazgos adicionales:</span>
              </v-col>
              <v-col cols="12" sm="8" md="8" lg="9">
                <v-select
                  v-model="additionalFindings"
                  :items="listAdditionalFindings"
                  placeholder="Seleccionar una opción"
                  solo
                  hide-details
                  dense
                  :error-messages="errors"
                />
              </v-col>
            </v-row>
          </ValidationProvider>

            <!-- 3) OTRAS ALTERACIONES -->
            <ValidationProvider
            name="Otras alteraciones"
            rules="required"
            v-slot="{ errors }"
            v-if="showOtherAlterations"
          >
            <v-row class="align-center" v-if="showOtherAlterations">
              <v-col cols="12" sm="4" md="4" lg="3" class="text-right">
                <span class="font-weight-bold"
                  >Otras Alteraciones (especifique):</span
                >
              </v-col>
              <v-col cols="12" sm="8" md="8" lg="9">
                <v-text-field
                  v-model="otherAlterations"
                  label="Otras Alteraciones"
                  clearable
                  :error-messages="errors"
                />
              </v-col>
            </v-row>
          </ValidationProvider>

            <h4 class="font-weight-bold mb-4" style="margin-top: 20px;">
              {{ categoryName }}
            </h4>

              <v-data-table
                :headers="headersBioMolecular"
                :items="itemsBioMolecular"
                hide-default-footer
                dense
               >
              <template v-slot:[`item.parametro`]="{ item }">
                {{ item.parametro }}
              </template>

              <template v-slot:[`item.resultado`]="{ item }">
                <ValidationProvider :name="item.parametro" rules="required" v-slot="{ errors }">
                <v-select
                  v-model="item.resultadoSelected"
                  :items="item.referenceResults"
                  item-text="value"
                  item-value="value"
                  hide-details
                  dense
                  outlined
                  placeholder="Seleccione..."
                  :error-messages="errors"
                />
              </ValidationProvider>
              </template>

              <template v-slot:[`item.unidad`]="{ item }">
                {{ item.unidad || "–––" }}
              </template>

              <template v-slot:[`item.referencia`]="{ item }">
                <span
                  v-if="item.referenceValues && item.referenceValues.length"
                >
                  <span
                    v-for="(refVal, idx) in item.referenceValues"
                    :key="idx"
                  >
                    {{ refVal.value }}
                  </span>
                </span>
                <span v-else>–––</span>
              </template>
            </v-data-table>

            <v-row class="ml-2 mt-7" align="center">
              <v-col md="4" offset="2">
                <v-text-field
                  v-model="metodo"
                  :counter="200"
                  label="Método"
                  disabled
                  required
                  prepend-icon="mdi-pencil-remove-outline"
                  autocomplete="off"
                />
              </v-col>
              <v-col md="4">
                <v-text-field
                  v-model="muestra"
                  :counter="200"
                  label="Muestra"
                  disabled
                  required
                  prepend-icon="mdi-file-document"
                  autocomplete="off"
                />
              </v-col>
            </v-row>

            <v-col cols="12">
   <h3>Observaciones</h3>
  </v-col>
  <v-col cols="12">
    <validation-provider
      v-slot="{ errors }"
      name="Observaciones"
      rules="required"
    >
      <v-textarea
        v-model="observation"
        outlined
        auto-grow
        :error-messages="errors"
        label="Observaciones"
        rows="6"
        class="mb-4"
      />
    </validation-provider>
  </v-col>

  <v-row align="center" justify="center" class="mb-4 mt-4">
    <v-col cols="6">
      <h3 class="font-weight-black mb-5" align="center" >Adjuntar archivos</h3>

      <!-- Input de archivos -->
      <v-row align="center" justify="center">
        <v-col cols="8">
          <validation-provider
          v-slot="{ errors }"
          name="Adjuntar archivo"
          rules="required"
        >
          <v-file-input
            v-model="papFiles"           
            placeholder="Seleccione el archivo"
            label="Adjuntar archivo"
            accept=".pdf"                
            show-size
            counter
            prepend-icon="mdi-paperclip"
            :disabled="isViewPapForm"
            :error-messages="errors"
            required
          />
        </validation-provider>
        </v-col>
      </v-row>

      <!-- Vista previa de archivos -->
      <v-row class="d-flex flex-nowrap" align="start" justify="center">
        <v-col
          cols="3"
          class="text-center"
          v-for="(file, index) in papFilesList"
          :key="index"
        >
          <template v-if="isImage(file.fileName)">
            <!-- Imágenes -->
            <img
              :src="file.base64 ? 'data:image/png;base64,' + file.base64 : file.url"
              style="width: 100%; height: auto; border-radius: 8px;"
              :alt="file.fileName"
            />
            <h3 style="font-size: 100%; text-align: center">{{ file.fileName }}</h3>
          </template>

          <template v-else-if="isPdf(file.fileName)">
            <!-- PDFs -->
            <v-icon size="100px" color="red">mdi-file-pdf-box</v-icon>
            <h3 style="font-size: 100%; text-align: center">{{ file.fileName }}</h3>
            <v-btn small color="primary" @click="openPdf(file.base64, file.fileName)">Ver PDF</v-btn>
          </template>

          <template v-else>
            <!-- Archivos no compatibles -->
            <v-icon size="100px"   color="grey">mdi-file</v-icon>
            <h3 style="font-size: 100%; text-align: center">Archivo no compatible</h3>
          </template>

          <!-- Botón eliminar -->
          <v-btn
            v-if="!isViewPapForm"
            small
            color="red"
            class="mt-2"
            @click="removePapFile(index)"
          >
            <v-icon>mdi-delete</v-icon> Eliminar
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
          </v-card-text>

          <v-card-actions>
            <v-row align="center" justify="center">
              <v-col cols="10" class="text-center my-3">
                <v-btn color="error" outlined text @click="myPapModalVisible = false"  class="mr-8">
                  <v-icon left>mdi-chevron-left</v-icon> 
                    Volver
                </v-btn>
                <v-btn color="primary" outlined text :disabled="invalid" @click="cerrarPap()">
                    Finalizar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </ValidationObserver>

      <v-dialog v-model="dialogInfoConsulta" max-width="60%">
        <v-card>
          <v-card-title class="text-h6 font-weight-bold px-9">
            Información de consulta
          </v-card-title>

          <v-card-text>
            <v-container dense>
              <v-row>
                <v-col cols="12">
                  <v-banner
                    shaped
                    single-line
                    class="white--text mb-4"
                    style="background-color: #60845c;"
                  >
                    Signos vitales
                  </v-banner>
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="4"
                  v-for="(vs, index) in vitalSignConsulta"
                  :key="index"
                >
                  <v-text-field
                    :label="vs.label"
                    :value="vs.value"
                    :suffix="vs.suffix"
                    disabled
                    dense
                  />
                </v-col>
              </v-row>

              <v-row class="mt-6">
                <v-col cols="12">
                  <v-banner
                    shaped
                    single-line
                    class="white--text mb-4"
                    style="background-color: #60845c;"
                  >
                    Antecedentes Patológicos
                  </v-banner>
                </v-col>
              </v-row>
              <v-expansion-panels multiple class="mb-4">
                <v-expansion-panel
                  v-for="(item, index) in pathologicalsConsulta"
                  :key="'pat-' + index"
                >
                  <v-expansion-panel-header>
                    {{ item.name }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col
                        v-for="(question, i) in item.questions"
                        :key="'patQ-' + i"
                      >
                        <v-textarea
                          outlined
                          readonly
                          :value="question.answer"
                          rows="2"
                          class="mb-2"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-expansion-panels multiple class="mb-4">
                <v-expansion-panel
                  v-for="(item, index) in heredoFamiliarConsulta"
                  :key="'hf-' + index"
                >
                  <v-expansion-panel-header>
                    {{ item.name }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col
                        v-for="(question, i) in item.questions"
                        :key="'hfQ-' + i"
                      >
                        <v-textarea
                          outlined
                          readonly
                          :value="question.answer"
                          rows="2"
                          class="mb-2"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-expansion-panels
                multiple
                v-if="dataModal.sexPatient === 'Femenino'"
              >
                <v-expansion-panel
                  v-for="(item, index) in gynecologicalConsulta"
                  :key="'gyQ-' + index"
                >
                  <v-expansion-panel-header>
                    {{ item.name }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row dense>
                      <v-col cols="4">
                        <div
                          v-for="(q, idx) in item.questions.slice(0, 5)"
                          :key="'gyColA-' + idx"
                        >
                          <strong>{{ q.name }}:</strong> {{ q.answer }}
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div
                          v-for="(q, idx) in item.questions.slice(5, 10)"
                          :key="'gyColB-' + idx"
                        >
                          <strong>{{ q.name }}:</strong> {{ q.answer }}
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div
                          v-for="(q, idx) in item.questions.slice(10, 15)"
                          :key="'gyColC-' + idx"
                        >
                          <strong>{{ q.name }}:</strong> {{ q.answer }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-row class="mt-6">
                <v-col cols="12">
                  <v-banner
                    shaped
                    single-line
                    class="white--text mb-4"
                    style="background-color: #60845c;"
                  >
                    Diagnóstico
                  </v-banner>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="cieSelectedConsulta"
                    :items="cieConsulta"
                    item-text="text"
                    item-value="value"
                    multiple
                    chips
                    disabled
                    label="Diagnóstico"
                    no-data-text="Sin resultados"
                  />
                </v-col>
              </v-row>

              <v-row align="center" justify="center" class="mt-4">
                <v-col cols="12" md="8" sm="12">
                  <span>Detalles de diagnóstico</span>
                  <v-textarea
                    v-model="diagnosticDetailsConsulta"
                    solo
                    outlined
                    dense
                    readonly
                    disabled
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="text-center">
            <v-col>
              <v-btn color="error" text @click="dialogInfoConsulta = false">
                <v-icon left>mdi-chevron-left</v-icon> Volver
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Datatable from "../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../components/Sidebar";
import BtnAccion from "../components/btnAccion.vue";
import {
  StudyRequest,
  ReportPDFRequest,
  ModaltyRequest,
  StudyModalityRequest,
  VitalSignRequest,
  EvaluationRequest,
  MedicalPracticeRequest,
} from "@/core/request";
import { UtilFront } from "@/core";
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import AutoLogout from "../components/AutoLogout.vue";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import BranchOfficesList from "../components/BranchOfficesList.vue";
import ExportImportBtn from "../components/ExportImportBtn.vue";
import CONSTANST from "@/app/core/Constants.js";

import ViewImageItem from "@/app/components/common/study/ViewImageItem.vue";
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientInterpretationAppoInfo from "@/app/components/interpretation/PatientInterpretationAppoInfo.vue";

extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});

export default {
  name: "CerrarEstudio",
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    BtnAccion,
    Loader,
    AutoLogout,
    ValidationObserver,
    ValidationProvider,
    BranchOfficesList,
    ExportImportBtn,
    ViewImageItem,
    ViewImageItem,
    PatientInformation,
    PatientInterpretationAppoInfo,
  },
  data: () => ({
    paramsRoute: {},
    acronym: "TD",
    valid: true,
    dialog: false,
    dialog2: false,
    dialog3: false,
    sending: false,
    search: "",
    myPapModalVisible: false,
    observation: "",
    observaciones: "",
    dialogInfoConsulta: false,
    dataModal: "",
    colposcopyFiles: [],
    laboratoryResults: {},
    tipoEstudio: "",
    tagModal: "",
    reason: "",
    speciality: "",
    encabezado: { icono: "mdi-folder-lock", texto: "Estudios por cerrar" },
    list: [],
    headers: [
      { text: "Id Estudio", value: "idStudy", align: "center" },
      { text: "Accession Number", value: "accessionNumber", align: "center" },
      { text: "Id Paciente", value: "idPatient", align: "center" },
      {
        text: "Nombre del paciente",
        value: "fullNamePatient",
        align: "center",
      },
      { text: "Estudio", value: "nameStudy", align: "center" },
      { text: "Modalidad", value: "nameModality", align: "center" },
      {
        text: "Fecha y hora de inicio del estudio",
        value: "startDate",
        align: "center",
      },
      { text: "Acciones", value: "actions", sortable: false, align: "center" },
    ],
    btnCloseStudy: {
      route: "/imagen/cerrar",
      icon: "mdi-close",
      text: "Cerrar estudio",
      tooltip: "Cerrar estudio",
    },
    btnPending: {
      route: "/interpretacion/pendientes",
      icon: "mdi-clock-alert-outline",
      text: "Interpretaciones pendientes",
      tooltip: "Ver Interpretaciones pendientes",
    },
    btnProcess: {
      route: "/imagen/comenzar",
      icon: "mdi-play-circle",
      text: "Estudios pendientes",
      tooltip: "Ver estudios pendientes",
    },
    service: StudyRequest,
    reasonRules: [(v) => !!v || "El motivo de la cancelación es obligatorio"],
    quantityRules: [(v) => !!v || "La cantidad de etiquetas es obligatorio"],
    quantityImages: 0,
    modalities: [],
    studyProfileList: [],
    modalitiesSelect: [],
    vitalSignConsulta: [],
    gynecologicalConsulta: [],
    pathologicalsConsulta: [],
    heredoFamiliarConsulta: [],
    cieSelectedConsulta: [],
    cieConsulta: [],
    diagnosticDetailsConsulta: "",
    resultsCytology: null,
    additionalFindings: null,
    otherAlterations: "",
    papFiles: [],
    papFilesList: [],
    isViewPapForm: false,
    listResultsCytology: [],
    listAdditionalFindings: [],
    showOtherAlterations: false,
    modalDate: { start: null, end: null },
    dialogPapa: false,
    headersBioMolecular: [
      { text: "Parámetro", value: "parametro", align: "left" },
      { text: "Resultado", value: "resultado", align: "left" },
      { text: "Unidad", value: "unidad", align: "left" },
      { text: "V. Referencia", value: "referencia", align: "left" },
    ],
    model: {
      telemedicineFiles: [],
    },
    studyProfileSelect: null,
    titleClose: "Cerrar estudio",
    idBranchOfficeSelected: null,
    cols: "col-md-2 col-xl-2 col-sm-12",
    date: "",
  }),
  mounted() {
    this.listAllModalities();
    this.listAllStudiesProfile();
    this.listAll();
    this.validBrowserTab();
    this.btnCloseStudy.route =
      this.speciality == 2 ? "/imagen/cerrar" : "/laboratorio/cerrar";
    this.btnPending.route =
      this.speciality == 2
        ? "/interpretacion/pendientes"
        : "/laboratorio/interpretacion/pendientes";
    this.btnProcess.route =
      this.speciality == 2 ? "/imagen/comenzar" : "/laboratorio/comenzar";
    this.titleClose =
      this.speciality == 2 ? "Cerrar estudio" : "Validar estudio";
  },
  computed: {
    // nameRoute: function () {
    //   if (this.$utilFront.getRole() == "Químico" && this.speciality == 3) {
    //     return "IniciarEstudio2";
    //   } else if (
    //     this.$utilFront.getRole() == "Radiólogo" &&
    //     this.speciality == 2
    //   ) {
    //     return "IniciarEstudio1";
    //   }
    //   return;
    // },
    dateCompuded() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return "";
      }
      return `${moment(this.date.start).format("DD/MM/YYYY")} al ${moment(
        this.date.end
      ).format("DD/MM/YYYY")}`;
    },
    dateRangeSelected() {
      return Boolean(this.modalDate.start && this.modalDate.end);
    },
    validData() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return false;
      }
      this.listAll();
      return true;
    },
    validColpo() {
      if (this.dataModal.nameModality !== 'COLPOSCOPIA') {
        return true;
      }
      const hasAnyFile =
        this.quantityImages > 0 ||
        (this.colposcopyFiles && this.colposcopyFiles.length > 0);

      const hasObs = (this.reason || '').trim().length >= 6;

      return hasAnyFile && hasObs;
    },
  },
  created() {
    let speciality1 = localStorage.getItem("speciality");
    this.speciality = this.$route.params.speciality;
    if (this.speciality == undefined || this.speciality == "") {
      this.speciality = speciality1;
      if (this.$utilFront.isEmpty(speciality1)) {
        if (this.$route.path.includes("imagen")) {
          this.speciality = 2;
        } else if (this.$route.path.includes("laboratorio")) {
          this.speciality = 3;
        } else {
          this.speciality = 2;
        }
      }
    } else {
      localStorage.setItem("speciality", this.speciality);
    }
    if (this.speciality == 3) {
      this.headers = [
        { text: "Id Estudio", value: "idStudy", align: "center" },
        { text: "Id Etiqueta", value: "laboratoryLabel", align: "center" },
        { text: "Id Paciente", value: "idPatient", align: "center" },
        {
          text: "Nombre del paciente",
          value: "fullNamePatient",
          align: "center",
        },
        { text: "Estudio", value: "nameStudy", align: "center" },
        { text: "Modalidad", value: "nameModality", align: "center" },
        {
          text: "Fecha y hora de inicio del estudio",
          value: "startDate",
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ];
    }
    this.validateData();
  },
  watch: {
    additionalFindings(newVal) {
      const selected = this.listAdditionalFindings.find(
        (item) => item.value === newVal
      );
      this.showOtherAlterations =
        selected?.text === "Otras Alteraciones (especifique)";
      if (!this.showOtherAlterations) {
        this.otherAlterations = "";
      }
    },
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    async downloadReport(typeFile) {
      this.sending = true;

      let parameters = {
        status: 3,
        typeFile: typeFile,
        acronym: this.acronym,
        speciality: this.speciality,
        typeReport: CONSTANST.TYPE_REPORT_STUDY_TO_CLOSE,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : UtilFront.getIdBranchOffice(),
        modalities: UtilFront.nonEmpty(this.modalitiesSelect)
          ? [this.modalitiesSelect]
          : [],
        idStudyModality: UtilFront.nonEmpty(this.studyProfileSelect)
          ? this.studyProfileSelect
          : null,
      };
      if (this.$utilFront.nonEmpty(this.date)) {
        parameters.startDate = this.$utilFront.startOfDay(this.date.start);
        parameters.finishDate = this.$utilFront.endOfDay(this.date.end);
      }

      let fileName = "";
      if (this.speciality == 2) {
        parameters.fileName = typeFile == 1 ? "Imagen.pdf" : "Imagen.xlsx";
      } else if (this.speciality == 3) {
        parameters.fileName =
          typeFile == 1 ? "Laboratorio.pdf" : "Laboratorio.xlsx";
      }
      fileName = parameters.fileName;

      ReportPDFRequest.exportlaboratory(parameters)
        .then((res) => {
          if (this.$utilFront.isJSON(res.data.type)) {
            this.$utilFront.displayErrorBlog(res.data);
          } else {
            switch (typeFile) {
              case 1: //PDF
                this.$utilFront.openPDF(res.data);
                break;
              case 2: //XLSX
                this.$utilFront.downloadXLSX(res.data, fileName);
                break;
            }
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },

    async onConfirmPapa() {
      if (!this.dateRangeSelected) return;
      this.sending = true;

      const parameters = {
        status: 3,
        acronym: "PAP",
        speciality: "2",
        typeReport: 2,
        idBranchOffice: this.idBranchOfficeSelected ?? UtilFront.getIdBranchOffice(),
        modalities: [],
        idStudyModality: "SMPAP-01",
        fileName: "Estudios Pendientes - Papanicolaou.xlsx",
        startDate: this.$utilFront.startOfDay(this.modalDate.start),
        finishDate: this.$utilFront.endOfDay(this.modalDate.end),
      };

      try {
        const res = await StudyRequest.papanicolaouDowloadExcel(parameters);
        this.$utilFront.downloadXLSX(res.data, parameters.fileName);
      } catch (err) {
        console.error("Error al descargar Excel:", err);
      } finally {
        this.sending = false;
        this.dialogPapa = false;
        this.modalDate = { start: null, end: null };
      }
    },
  

    validBrowserTab() {
      this.validTab();
    },
    clearCalendar() {
      this.date = "";
      this.listAll();
    },
    catchError: (e) => {
      // console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    listAllModalities() {
      let post = {
        idSpeciality: this.speciality,
      };
      ModaltyRequest.listModaltyByHumanResourceAndSpecialty(post).then(
        (res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.modalities = res.data.data.map((modality) => {
              return {
                idModality: modality.idModality,
                name: modality.acronym + " - " + modality.name,
                speciality: modality.speciality || "--- Sin información ---",
                acronym: modality.acronym,
              };
            });
            // this.modalitiesSelect = res.data.data.map((modality) => {
            //   return {
            //     idModality: modality.idModality,
            //   };
            // });
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.modalities = [];
          }
        }
      );
    },
    listAllStudiesProfile() {
      if (!this.loader) {
        this.loader = true;
      }

      let idModality = UtilFront.nonEmpty(this.modalitiesSelect)
        ? this.modalitiesSelect
        : null;
      StudyModalityRequest.listStudyModalityBySpecialityAndUser(
        this.speciality,
        idModality
      )
        .then((res) => {
          let studyprofile = res.data.data;
          this.studyProfileList = studyprofile;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    listAll() {
      this.sending = true;

      let parameters = {
        status: 3,
        acronym: this.acronym,
        speciality: this.speciality,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : UtilFront.getIdBranchOffice(),
        modalities: UtilFront.nonEmpty(this.modalitiesSelect)
          ? [this.modalitiesSelect]
          : [],
        idStudyModality: UtilFront.nonEmpty(this.studyProfileSelect)
          ? this.studyProfileSelect
          : null,
      };

      if (this.$utilFront.nonEmpty(this.date)) {
        parameters.startDate = this.$utilFront.startOfDay(this.date.start);
        parameters.finishDate = this.$utilFront.endOfDay(this.date.end);
      }

      StudyRequest.listAllByStatus(parameters)
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            let data = res.data.data;
            if (data) {
              data.sort(function(a, b) {
                return new Date(a.startDate) - new Date(b.startDate);
              });
            }
            this.list = data.map((study) => {
              let sex;
              if (study.gender === "H") {
                sex = "Masculino";
              } else if (study.gender === "M") {
                sex = "Femenino";
              } else if (study.gender === "X") {
                sex = "No binario";
              }
              return {
                idStudy: study.idStudy,
                accessionNumber: study.accessionNumber ?? "N/A",
                idPatient: study.idPatient,
                fullNamePatient: study.patient || "---",
                nameModality: study.modality || "---",
                nameStudy: study.studyModality || "---",
                startDate:
                  moment(new Date(study.startDate))
                    .locale("es")
                    .format("DD/MM/YYYY HH:mm") || "---",
                nacPatient:
                  moment(new Date(study.birthDate))
                    .locale("es")
                    .format("DD/MM/YYYY") || "---",
                // sexPatient: study.gender === "H" ? "Masculino" : "Femenino",
                sexPatient: sex,
                idPerson: study.idPerson,
                laboratoryLabel: UtilFront.nonEmpty(study.laboratoryLabel)
                  ? study.laboratoryLabel
                  : study.accessionNumber,
              };
            });
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    async close(item) {
    const spec = Number(this.speciality);

    if (spec === 2) {
      if (item.nameModality === 'COLPOSCOPIA') {
        this.dataModal       = { ...item };
        this.reason          = '';
        this.colposcopyFiles = [];
        this.sending         = true;
        this.dialog          = true;

        try {
          const res = await StudyRequest.validatePACS({ idStudy: item.idStudy });
          const { code, data } = res.data;
          if (code === 200 && data >= 1) {
            this.quantityImages = data;
            this.dialog = true;
          } else {
            this.$utilFront.notifications(
              'El estudio no cuenta con imágenes asignadas.',
              'WARNING'
            );
          }
        } catch (err) {
          console.error('Error validando imágenes:', err);
          this.$utilFront.notifications(
            'Error al validar imágenes de Colposcopia.',
            'ERROR'
          );
        } finally {
          this.sending = false;
        }
      }
      else if (item.nameModality === 'PAPANICOLAOU') {
        StudyRequest.papanicolaouForm({
          evaluationTypes: [14],
          idPerson:        item.idPerson,
          idStudy:         item.idStudy
        })
        .then((res) => {
          const questions = res.data[0]?.dataQuestions || [];
          questions.forEach((question) => {
            if (question.name === 'Resultados del estudio citológico') {
              this.listResultsCytology = question.answers.map(ans => ({
                text:  ans.name,
                value: ans.idAnswer
              }));
            }
            if (question.name === 'Hallazgos adicionales') {
              this.listAdditionalFindings = question.answers.map(ans => ({
                text:  ans.name,
                value: ans.idAnswer
              }));
            }
          });
        })
        .catch(console.error);

        StudyRequest.papanicolaouTable({ idStudy: item.idStudy })
        .then((res) => {
          const data     = res.data.data;
          const category = data.categories[0];
          this.categoryName     = category.name;
          this.itemsBioMolecular = category.parameters.map(param => ({
            idParameter:     param.idParameter,
            parametro:       param.name,
            referenceValues: param.referenceValues,
            referenceResults:param.referenceResults,
            resultadoSelected: param.result?.result || null,
            unidad:           param.unitMeasurement || ''
          }));
          this.metodo   = category.method || '';
          this.muestra  = category.sample || '';

          this.dataModal         = { ...item };
          this.myPapModalVisible = true;  // abre modal de papa
        })
        .catch(err => console.error('Error en el formulario =>', err));
      }
      else {
        this.validatePACS(item);
      }
    }

    else if (spec === 3) {
      this.$router.push({
        name: 'ResultadosLaboratorio',
        params: {
          edit:       false,
          idStudy:    item.idStudy,
          idPaciente: item.idPatient,
          readOnly:   true,
          idPerson:   item.idPerson
        }
      });
    }
  },

  async cerrarPap() {
    this.sending = true
    try {
      await this.savePapForm()
      await this.saveBioResults()
      await this.uploadPapFiles()
      await this.finishAndRefresh()

      this.$utilFront.notifications(
        "Consulta guardada correctamente.",
        "SUCCESS"
      )
    } catch (error) {
      console.error("Error en cerrarPap:", error)
      this.$utilFront.notifications(
        "Error al guardar la consulta de Papanicolaou.",
        "ERROR"
      )
    } finally {
      this.sending = false
    }
},

  async savePapForm() {
    const dataQuestions = [
      {
        idQuestion: "QGIN-23",
        idAnswer: this.resultsCytology,
      },
      {
        idQuestion: "QGIN-24",
        answersClosed: this.additionalFindings
          ? [this.additionalFindings]
          : [],
        openAnswer:
          this.additionalFindings === "AGIN-99" && this.otherAlterations?.trim()
            ? this.otherAlterations.trim()
            : undefined,
      },
    ]

    const payload = {
      calculators: [{ idCalculator: "EGIN-03", dataQuestions }],
      idPerson: this.dataModal.idPerson,
      idStudy: this.dataModal.idStudy,
    }

    const resp = await StudyRequest.papanicolaouSaveForm(payload)
    if (resp.status !== 200) {
      this.$utilFront.notifications(
        "Ocurrió un error al guardar el formulario de Papanicolaou.",
        "ERROR"
      )
      throw new Error("SaveForm failed")
    }

  },

  async saveBioResults() {
    const results = this.itemsBioMolecular.map((item) => ({
      idResults: null,
      result: item.resultadoSelected,
      idParameter: item.idParameter,
    }))

    const payload = {
      idHumanResource: this.$utilFront.getIdHumanResource(),
      idStudy: this.dataModal.idStudy,
      observation: this.observation,
      idStudyResults: null,
      results,
    }

    const resp = await StudyRequest.papanicolaouSaveTable(payload)
    if (resp.status !== 200) {
      this.$utilFront.notifications(
        "Ocurrió un error al guardar resultados de Biología Molecular.",
        "ERROR"
      )
      throw new Error("SaveTable failed")
    }

  },

  async uploadPapFiles() {
    const files = this.getSelectedFiles()
    if (files.length === 0) return
    const formData = new FormData()
    formData.append("jsonData", JSON.stringify({ idStudy: this.dataModal.idStudy }))
    for (const file of files) {
      formData.append("files", file, file.name)
    }
    const resp = await StudyRequest.papanicolaouSaveFiles(formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    if (resp?.status !== 200) {
      this.$utilFront.notifications(
        "Error al adjuntar archivos de Papanicolaou",
        "ERROR"
      )
      throw new Error("SaveFiles failed")
    }
},

async handleAcceptModal() {
    // si es colposcopia subimos primero y luego cerramos
    if (this.dataModal.nameModality === 'COLPOSCOPIA') {
      await this.confirmColposcopyAndClose()
    } else {
      this.dialog = false
      await this.closeStudy(this.dataModal.idStudy, this.reason)
      await this.listAll()
    }
  },


  async uploadColposcopyFiles() {
    const files = this.colposcopyFiles || [];
    if (files.length === 0) return;

    const formData = new FormData();
    formData.append(
      'jsonData',
      JSON.stringify({ idStudy: this.dataModal.idStudy, studyFiles: true })
    );
    files.forEach(file => formData.append('files', file, file.name));

    const resp = await StudyRequest.papanicolaouSaveFiles(formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    if (resp?.status !== 200) {
      this.$utilFront.notifications(
        'Error al adjuntar archivos de Colposcopia',
        'ERROR'
      );
      throw new Error('SaveFiles failed');
    }
  },

  
   async confirmColposcopyAndClose() {
    this.sending = true
    try {
      // 1) subir PDFs
      await this.uploadColposcopyFiles()

      // 2) cerrar estudio (mismo payload que closeStudy)
      const payload = {
        idStudy: this.dataModal.idStudy,
        observation: this.reason,
        idUser: this.$utilFront.getIdUser()
      }
      const res = await StudyRequest.closeStudy(payload)
      if (res.data.code === 200 && res.data.status === 'OK') {
        // quitar de la lista en memoria
        const idx = this.list.findIndex(x => x.idStudy === this.dataModal.idStudy)
        if (idx !== -1) this.list.splice(idx, 1)

        this.$utilFront.notifications(
          'Estudio cerrado y archivos adjuntados correctamente',
          'SUCCESS'
        )
      } else if (res.data.code === 401) {
        this.unauthorized()
      } else {
        this.$utilFront.notifications('Error al cerrar el estudio', 'ERROR')
      }

      // 3) cerrar dialog y refrescar
      this.dialog = false
      await this.listAll()

    } catch (err) {
      console.error('Error en confirmColposcopyAndClose:', err)
      this.$utilFront.notifications('Ocurrió un error', 'ERROR')
    } finally {
      this.sending = false
      this.reason = ''
    }
  },

  async finishAndRefresh() {
    this.myPapModalVisible = false
    await this.listAll()
  },


  getSelectedFiles() {
    if (!this.papFiles) return []
    return Array.isArray(this.papFiles) ? this.papFiles : [this.papFiles]
  },
    validatePACS(item) {
      if (!this.sending) {
        this.sending = true;
        this.reason = "";
        this.quantityImages = 0;
        StudyRequest.validatePACS({ idStudy: item.idStudy })
          .then((res) => {
            let { data, status, code } = res.data;
            if (code == 200 && data >= 1) {
              this.quantityImages = data;
              this.dataModal = Object.assign(this.dataModal, item);
              this.dialog = true;
            } else if (code == 200 && data == false) {
              this.$utilFront.notifications(
                "El estudio no cuenta con imágenes asignadas.",
                "WARNING"
              );
            } else if (typeof data == "string") {
              this.$utilFront.notifications(
                data || "Sucedio un error",
                "ERROR"
              );
            } else {
              this.catchError();
            }
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      }
    },
    cancel(item) {
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, item);
      if (this.$utilFront.isNonNull(this.dataModal)) {
        this.dialog2 = true;
      }
    },
    closeStudy(study) {
      if (!this.sending) {
        this.sending = true;
        let postID = {
          idStudy: study,
          quantityImages: this.quantityImages,
          observation: this.reason,
          idUser: this.$utilFront.getIdUser(),
        };
        StudyRequest.closeStudy(postID)
          .then((res) => {
            if (res.data.data) {
              if (res.data.code === 200 && res.data.status === "OK") {
                for (let i = 0; i < this.list.length; i++) {
                  if (this.list[i].idStudy == study) {
                    this.list.splice(i, 1);
                  }
                }
                this.$utilFront.notifications(
                  "Estudio cerrado correctamente",
                  "SUCCESS"
                );
              } else if (res.data.code === 401) {
                this.unauthorized();
              } else {
                this.$utilFront.notifications(
                  "Error al cerrar el estudio",
                  "ERROR"
                );
              }
            }
          })
          .finally(() => {
            this.sending = false;
            this.reason = "";
          });
      }
    },
    cancelStudy(idStudy) {
      if (!this.sending) {
        if (this.$refs.form.validate()) {
          this.sending = true;
          let postID = {
            reason: this.reason,
            study: {
              idStudy: idStudy,
            },
          };
          StudyRequest.cancelStudy(postID)
            .then((res) => {
              if (res.data.data) {
                if (res.data.code === 200 && res.data.status === "OK") {
                  for (let i = 0; i < this.list.length; i++) {
                    if (this.list[i].idStudy == idStudy) {
                      this.list.splice(i, 1);
                    }
                  }
                  this.$utilFront.notifications(
                    "Estudio cancelado correctamente",
                    "SUCCESS"
                  );
                  this.dialog2 = false;
                } else if (res.data.code === 401) {
                  this.unauthorized();
                } else {
                  this.$utilFront.notifications(
                    "Error al cancelar el estudio",
                    "ERROR"
                  );
                }
              }
            })
            .finally(() => {
              this.sending = false;
              this.reason = "";
            });
        }
      }
    },

    checkDetail(item) {
      localStorage.setItem("idStudy", item.idStudy);
      if (this.speciality == 3) {
        this.$router.push({
          name: "DetalleEstudio2",
          // params: { idStudy: item.idStudy },
          params: item,
        });
      } else {
        this.$router.push({
          name: "DetalleEstudio1",
          params: item,
        });
      }
    },

    openInfoConsulta(item) {
      this.dataModal = { ...item };

      let mpPromise = this.getMedicalPracticeInfoConsulta(item.idStudy);

      let vsPromise = VitalSignRequest.findAllByPatientOrStudyOrMedicalPractice(
        {
          idStudy: item.idStudy,
        }
      ).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.vitalSignConsulta = res.data.data.map((v) => ({
            label: v.vitalSignType.name,
            value: v.description,
            suffix: v.vitalSignType.suffix,
          }));
        }
      });

      let antPromise = this.getAntecedentsForModal(item.idPerson);

      Promise.all([mpPromise, vsPromise, antPromise]).finally(() => {
        this.dialogInfoConsulta = true;
      });
    },
    getMedicalPracticeInfoConsulta(idStudy) {
      const token = localStorage.getItem("token");
      return MedicalPracticeRequest.listMedicalPracticeDetails(
        { idStudy },
        { headers: { Authorization: token } }
      ).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          const data = res.data.data;
          // Diagnósticos
          this.cieSelectedConsulta = data.cie10.map((c) => c.cie10.idCIE10);
          this.cieConsulta = data.cie10.map((c) => ({
            text: c.cie10.key + " - " + c.cie10.name,
            value: c.cie10.idCIE10,
          }));

          this.diagnosticDetailsConsulta =
            data.diagnosticPersonInfo?.diagnosticDetails || "";
        } else if (res.data.code === 401) {
          this.unauthorized();
        } else {
          console.warn("Error al obtener MedicalPractice:", res.data);
        }
      });
    },
    getAntecedentsForModal(idPerson) {
      return EvaluationRequest.listByPersonAndType({ type: 2, idPerson })
        .then((res) => {
          if (res.data.response) {
            this.pathologicalsConsulta = res.data.data;
          }
        })
        .finally(() => {
          EvaluationRequest.listByPersonAndType({ type: 3, idPerson })
            .then((res) => {
              if (res.data.response) {
                this.heredoFamiliarConsulta = res.data.data;
              }
            })
            .finally(() => {
              EvaluationRequest.listByPersonAndType({ type: 4, idPerson }).then(
                (res) => {
                  if (res.data.response) {
                    this.gynecologicalConsulta = res.data.data;
                  }
                }
              );
            });
        });
    },

    validateData() {
      let ls = JSON.parse(localStorage.getItem("modality")) || {};
      let data = ls;

      let nameModality = "Todas";
      this.acronym = "TD";
      if (!(typeof data.acronym === "undefined")) {
        nameModality = data.title;
        this.acronym = data.acronym;
      }
      if (this.speciality == 2) {
        this.encabezado.texto = "Estudios por cerrar";
      } else if (this.speciality == 3) {
        this.encabezado.texto = "Estudios por validar | Laboratorio";
      }
    },

    dialogTag(item) {
      this.dialog3 = true;
      this.tagModal = item;
    },
    downloadBarcode(study) {
      this.sending = true;
      try {
        let data = {
          idStudy: study,
          fileName: "Codigo de barras",
          quantityTags: 1,
        };
        ReportPDFRequest.downloadBarcodeLaboratory(data);
      } catch (e) {
        this.catchError(e);
      } finally {
        this.dialog3 = false;
        this.sending = false;
      }
    },
    closeCancel() {
      this.dialog2 = false;
      this.dataModal = "";
      this.$refs.form.reset();
      this.$refs.observer.reset();
    },
    cancelAction() {
      this.dialog = false;
      this.dataModal = "";
    },
    isViewAdmin() {
      return UtilFront.isViewAdmin();
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      // this.listAllModalities();
      this.listAll();
    },
    filterModality() {
      this.studyProfileSelect = null;
      this.listAllStudiesProfile();
      this.listAll();
    },
  },
};
</script>
